import {Component, OnInit} from '@angular/core';
import {PermisoEntity, RolEntity} from '../../CoreModule/entities/usuario.entity';
import {RolServices} from '../../CoreModule/services/rol.services';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector:"rol-list",
  templateUrl:"../templates/roles/rol.list.template.html"
})
export class RolCrudComponent implements OnInit{

  public roles:RolEntity[] = [];

  constructor(private rs:RolServices){}


  ngOnInit() {
    this.rs.getRoles().subscribe(d=>{
      console.log(d);
      this.roles = d.data.rols;
    })
  }

}

@Component({
  selector:"rol-new",
  templateUrl:"../templates/roles/rol.new.template.html"
})
export class RolNewComponent implements OnInit{

  public rol:RolEntity = new RolEntity();
  public permisos:PermisoEntity[] = [];

  permisosSelect:any[] = [];

  constructor(private rs:RolServices){}

  ngOnInit(): void {
    this.rs.getPermisos().subscribe(d=>{
      this.permisos = d.data.permisos;
    })
  }

  guardarRol(){

    this.rol.permisos = [];
    this.permisosSelect.map(p=>{
      this.rol.permisos.push(+p);
    });
    this.rs.creteRol(this.rol).subscribe(d=>{
      alert("Rol creado con exito");
    })
  }

}

@Component({
  selector:"rol-edit",
  templateUrl:"../templates/roles/rol.edit.template.html"
})
export class RolEditComponent implements OnInit{

  public rol:RolEntity;
  public permisos:PermisoEntity[] = [];

  permisosSelect:any[] = [];

  constructor(private rs:RolServices, private activeRouter:ActivatedRoute){}

  ngOnInit(): void {
    let id = +this.activeRouter.snapshot.params.id;



    this.rs.getRol(id).subscribe(d=>{
      this.rol = d.data.rol;




      d.data.rol.permisos.map(p=>{
        this.permisosSelect.push(p.id);
      })

      // console.log(this.rol);


    });

    this.rs.getPermisos().subscribe(d=>{
      this.permisos = d.data.permisos;
    });

  }

  guardarRol(){
    this.rol.permisos = [];
    this.permisosSelect.map(p=>{
      this.rol.permisos.push(+p);
    });


    this.rs.updateRol(this.rol).subscribe(d=>{
      alert("Actualizacion de rol realizada con exito");
    })
  }

}
